export default {"src":"/_next/static/media/DownArrowBrown.4b1d6306.svg","height":7,"width":12,"blurWidth":0,"blurHeight":0};